import React from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import ImportScreen from "components/ImportScreen"
import EmptyButton from "components/EmptyButton"
import { LeftOutlined } from "@ant-design/icons"
import emptySvg from "../../images/emptyImportRecipients.svg"
import alertSvg from "../../images/alert.svg"
import ModalCustom from "components/ModalCustom"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import makeSelectMeasurementRecipientsImport, {
  makeSelectIsDownloading,
  makeSelectIsUploading,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import { getTemplate, uploadTemplate } from "./actions"
import { LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_s } from "../../components/Snowplow/config2"

export function MeasurementImportRecipients(props) {
  let fileInput
  // snowplow
  let data_button_import = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: "Importar destinatarios",
    label: "Click a Importar destinatarios",
    property: "Button",
    value: LOCAL_USER_ID(),
  }
  const [showModalReturn, setShowModalReturn] = React.useState()

  const fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])

    props.uploadTemplate(fd)
    buttonAction_s(data_button_import)
    fileInput.value = ""
  }

  return (
    <>
      <Helmet>
        <title>Importar Destinatarios</title>
      </Helmet>
      <div style={{ padding: "32px 64px" }}>
        <a
          style={{
            display: "flex",
            alignItems: "center",
          }}
          onClick={() => setShowModalReturn(true)}>
          <LeftOutlined /> Seleccionar destinatarios
        </a>
      </div>
      <ImportScreen
        title="Importa destinatarios"
        image={emptySvg}
        description="Selecciona los destinatarios de la medición de forma masiva a través de un archivo importable de Excel."
        secondPoint="Llena los campos con la información de los destinatarios."
        thirdPoint="Importa el Excel a la plataforma.">
        <EmptyButton
          size="large"
          label="Descargar plantilla"
          loading={props.isDownloading}
          onClick={() => props.getTemplate(true)}
        />
        <EmptyButton
          size="large"
          onClick={() => fileInput.click()}
          loading={props.isUploading}
          label="Importar destinatarios"
          style={{ marginLeft: "2rem" }}
        />
        <input
          id="import"
          style={{ display: "none" }}
          type="file"
          onChange={fileSelectedHandler}
          ref={(_fileInput) => (fileInput = _fileInput)}
        />
      </ImportScreen>

      <ModalCustom
        showFooter
        textButton="Salir"
        modalOpen={showModalReturn}
        onCancel={() => setShowModalReturn(false)}
        onOk={() =>
          props.history.push(
            `/models/measure-create/${props.match.params.id}?step=3`
          )
        }>
        <img src={alertSvg} className="alertIcon" />
        <p style={{ fontSize: 14, fontWeight: 600 }}>
          ¿Estás seguro de que deseas salir de la importación?
        </p>
        <p style={{ fontSize: 13 }}>
          La información no será registrada y deberás iniciar un nuevo proceso
          de importación.
        </p>
      </ModalCustom>
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  measurementRecipientsImport: makeSelectMeasurementRecipientsImport(),
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
})

const mapDispatchToProps = (dispatch) => {
  return {
    getTemplate: (params) => dispatch(getTemplate(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "measurementRecipientsImport",
  reducer,
})
const withSaga = injectSaga({ key: "measurementRecipientsImport", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(MeasurementImportRecipients)
